import { render, staticRenderFns } from "./PointersOfMonthEdit.vue?vue&type=template&id=3e990678&scoped=true"
import script from "./PointersOfMonthEdit.vue?vue&type=script&lang=js"
export * from "./PointersOfMonthEdit.vue?vue&type=script&lang=js"
import style0 from "./PointersOfMonthEdit.vue?vue&type=style&index=0&id=3e990678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e990678",
  null
  
)

export default component.exports